import React from "react";
import {DealershipsTable} from './DealershipsTable';
import '../../styles/SelectDealerships.scss';
import {CONSTANTS} from '../../constants';

export const SelectDealerships = ({apiDetails, apiIntegrationDetails: {locationsGroupByApi}, subscriptionData, isNewApi}) => {
    const {id, apiDisplayName, apiType} = apiDetails;
    const integrationsDataPerLocation = 
            subscriptionData?.map(s => {
                const integration = locationsGroupByApi[id]?.find(i => i.entityId === s.entityId);
                return integration || {
                    entityId: s.entityId,
                }
            }); 

    return (
        <div data-testid="step-select-dealerships" className='locations-step__container'>
            <p data-testid="select-dealership-description" className="locations-step__description">
                {CONSTANTS.SELECT_DEALERSHIP} <span className="locations-step__apiName">{apiDisplayName}</span>
            </p>
            <DealershipsTable apiName={apiDisplayName} apiType={apiType} integrationsDataPerLocation={integrationsDataPerLocation} isNewApi={isNewApi}/>
        </div>
    )
};